import { defineStyleConfig } from '@chakra-ui/react';
import { sizes } from './common';

export default defineStyleConfig({
  baseStyle: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    w: 'auto',
  },
  sizes,
  defaultProps: {
    size: 'md',
  },
});
